import { useEffect, useState } from 'react'

import './index.scss'
import {usePermissions} from "../../../../components/hooks/usePermissions";
import {PERMISSIONS} from "../../../../consts/permissions";

const DeudasMenuVertical = ({ showButtons, handleClickPagoCuotas, handleClickPagoContado, handleClickVep }) => {
    const [expanded, setExpanded] = useState(false)
    const [vepExpanded, setVepExpanded] = useState(false)

    const { hasPermission } = usePermissions();
    const canEditCuentaPago = hasPermission(PERMISSIONS.CUENTA_PAGO_EDIT);
    const canEditVep = hasPermission(PERMISSIONS.VEP_EDIT);
    const canEditVepPlanes = hasPermission(PERMISSIONS.VEP_PLANES_EDIT);

    const canVep = canEditCuentaPago && canEditVep;
    const canPlanes = canEditCuentaPago && canEditVepPlanes;

    const vepDisabled = !showButtons.ReciboComun;
    const planesDisabled = !(showButtons.PagoContado || showButtons.PagoCuotas);

    useEffect(() => {
        if (planesDisabled && expanded) {
            setExpanded(false)
        }
    }, [planesDisabled, expanded])

    useEffect(() => {
        if (vepDisabled && vepExpanded) {
            setVepExpanded(false)
        }
    }, [vepDisabled, vepExpanded])

    const togglePlanes = () => {
        setVepExpanded(false)
        setExpanded(x => !x)
    }

    const toggleVep = () => {
        setExpanded(false)
        setVepExpanded(x => !x)
    }

    const onClickVep = (esPresencial) => {
        setVepExpanded(false)
        handleClickVep(esPresencial)
    }

    return (
        <div className="deudas-actions">
            {canPlanes && (
                <div className="button-expand">
                    <button
                        className="btn action-button"
                        disabled={planesDisabled}
                        onClick={togglePlanes}
                    >
                        Crear plan de pago <span className="material-symbols-outlined caret">{expanded ? 'expand_less' : 'expand_more'}</span>
                    </button>

                    <div className={`button-expand-menu${expanded ? '' : ' hidden'}`}>
                        {showButtons.PagoContado && (
                            <button className="btn action-button menu-item" onClick={() => handleClickPagoContado()} title='Plan de pago contado'>
                                Contado <span className="material-symbols-outlined nav-indicator">open_in_new</span>
                            </button>
                        )}
                        {showButtons.PagoCuotas && (
                            <button className="btn action-button menu-item" onClick={() => handleClickPagoCuotas()} title='Plan de pago en cuotas'>
                                En cuotas <span className="material-symbols-outlined nav-indicator">open_in_new</span>
                            </button>
                        )}
                    </div>
                </div>
            )}

            {canVep && (
                <div className="button-expand">
                    <button
                        className="btn action-button"
                        disabled={vepDisabled}
                        onClick={toggleVep}
                    >
                        Generar VEP <span className="material-symbols-outlined caret">{vepExpanded ? 'expand_less' : 'expand_more'}</span>
                    </button>

                    <div className={`button-expand-menu${vepExpanded ? '' : ' hidden'}`}>
                        <button className="btn action-button" onClick={() => onClickVep(false)} title='VEP online'>
                            Online
                        </button>
                        <button className="btn action-button" onClick={() => onClickVep(true)} title='VEP presencial'>
                            Presencial
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default DeudasMenuVertical
